import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicBeachHouse from "../Components/ProjPicBeachHouse";

const ProjectPageBeachHouse = () => {
    return (
        <>
            <Navbar />
            <ProjPicBeachHouse />
            <Footer />
        </>
    );
};

export default ProjectPageBeachHouse;
